module.exports = __webpack_public_path__ + "build/img/luc_s.76591fba.png";